import React from "react";
import "./peripheralRow.css"

class PeripheralRow extends React.Component {
    constructor(props) {
        super(props);

        // This binding is necessary to make `this` work in the callback
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.clickCallback(this.props.peri);
    }

    render() {
        const peri = this.props.peri;
        const tdStyle ={
                color: 'lightgreen',
        fill:'lightgreen'};
        const minusStyle ={
            color: '#FF6666'};
        const plusStyle ={
            color: '#6666FF'};

        return (
            <tr className={this.props.index % 2 === 0 ? 'even' : 'odd'}>
                <td>
                    <div className="row-peripheral">
                        <button className="row-name" >
                            <span>
                                {peri.name}
                            </span>
                            {this.props.active && <span style={tdStyle} className="glyphicon glyphicon-ok"/>}

                        </button>
                        <button className="row-plus" onClick={this.handleClick}>
                            {this.props.selected ?
                                <span style={minusStyle} className="glyphicon glyphicon-minus-sign"/> :
                                <span style={plusStyle} className="glyphicon glyphicon-plus-sign"/>
                            }
                        </button>
                    </div>
                </td>
            </tr>
        );
    }
}

export default PeripheralRow;
